import {DataStatus} from 'platform/components';
import {Box, Grid, Heading, Text, VStack} from 'platform/foundation';
import {Nullish} from 'utility-types';

import {isNilOrEmpty} from 'ramda-adjunct';

import {useListEntityChangesQuery, useListRecordFieldChangesQuery} from '@dms/api/core';
import {EntityResourceIds} from '@dms/api/shared';

export interface ActivityChangeLogProps {
  commandId: string;
  resourceId: EntityResourceIds;
  recordId: string | Nullish;
}

export function ActivityChangeLog(props: ActivityChangeLogProps) {
  // raw level - commandId
  const {data: listEntityChangesData, isLoading: isListEntityChangesQueryLoading} =
    useListEntityChangesQuery({commandId: props.commandId});
  // field level - resourceId + recordId
  const {data: listRecordFieldChangesData, isLoading: isListRecordFieldChangesQueryLoading} =
    useListRecordFieldChangesQuery(
      {
        commandId: props.commandId,
        resourceId: props.resourceId,
        recordId: props.recordId!,
      },
      {skip: isNilOrEmpty(props.recordId)}
    );

  const isLoading = isListEntityChangesQueryLoading || isListRecordFieldChangesQueryLoading;

  return (
    <DataStatus isLoading={isLoading}>
      <VStack spacing={2}>
        <VStack>
          <Heading size={3}>List entity changes(raw level)</Heading>
          <Grid columns={4}>
            <Text>Class</Text>
            <Text>Property</Text>
            <Text>From</Text>
            <Text>To</Text>
            {listEntityChangesData?.map((entity) => (
              <>
                <Box overflow="auto">
                  <Text>{entity.class}</Text>
                </Box>
                <Box overflow="auto">
                  <Text>{entity.property}</Text>
                </Box>
                <Box overflow="auto">
                  <pre>{entity.from}</pre>
                </Box>
                <Box overflow="auto">
                  <pre>{entity.to}</pre>
                </Box>
              </>
            ))}
          </Grid>
        </VStack>
        <VStack>
          <Heading size={3}>List record field changes(prettified)</Heading>
          <Grid columns={3}>
            <Text>Property</Text>
            <Text>From</Text>
            <Text>To</Text>
            {listRecordFieldChangesData?.map((entity) => (
              <>
                <Box overflow="auto">
                  <Text>{entity.property}</Text>
                </Box>
                <Box overflow="auto">
                  <pre>{entity.from}</pre>
                </Box>
                <Box overflow="auto">
                  <pre>{entity.to}</pre>
                </Box>
              </>
            ))}
          </Grid>
        </VStack>
      </VStack>
    </DataStatus>
  );
}
